import { existsSync } from 'node:fs';
import { resolve } from 'node:path';

export function resolveSkillPaths(skills: string[], repoRoot: string): string[] {
  return skills
    .filter(s => s.endsWith('.md'))
    .map(s => resolve(repoRoot, s))
    .filter(p => existsSync(p));
}
